import React from 'react';
import logComponent from '../../common/logComponent';
import './Toggle.css';

export default function Toggle({ toggleValue, toggleValueParam, selected, showTextValue, trueText, falseText }) {
  if (logComponent('Toggle')) { console.debug('Toggle rendered'); }

  const handleClick = () => {
    if (logComponent('Toggle')) { console.debug('Toggle handleClick'); }

    if (toggleValueParam) {
      toggleValue(toggleValueParam);
    } else {
      toggleValue();
    }
  }

  return (
    <div
      className="Toggle"
      onClick={handleClick} >
      <svg className="Toggle__icon" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 101 61">
        <path className={'Toggle__slot' + (selected ? ' Toggle__slot--on' : '')} d="M 30 0 L 70 0 A 30 30 0 0 1 70 60 L 30 60 A 30 30 0 0 1 30 0" />
        <circle className={'Toggle__knob' + (selected ? ' Toggle__knob--on' : '')} cx="30" cy="30" r="24"></circle>
      </svg>
      {
        showTextValue &&
        <span className="Toggle__text">
          {(selected ? trueText : falseText)}
        </span>
      }
    </div>
  );
}